/** @format */

import { createSlice } from '@reduxjs/toolkit';
// import _ from 'lodash';
import axios from 'src/utils/axios';
import { ENDPOINTS } from 'src/constants';
import type { FooterLinksResponse } from 'src/types';
import { clearPublicContentError } from 'src/slices/publicContent';

const initialState = {
  globalLoading: false,
  footerLinks: null,
  error:null
};

const slice = createSlice({
  name: 'global',
  initialState,
  reducers: {

    //Get Footer Links

    getFooterLinks(state) {
      state.globalLoading = true;
    },
    getFooterLinksSuccess(state, action) {
      const { data } = action.payload;
      state.footerLinks = Array.isArray(data) ? data : data?.data ?? null;
      state.globalLoading = false;
    },
    getFooterLinksFailure(state, action) {
      const { error } = action.payload;
      state.error = error;
      state.globalLoading = false;
    },
    clearError(state) {
      state.error = null;
    }
  }
});

export const reducer = slice.reducer;

/** Dedupes StrictMode double-mount and concurrent callers. */
let footerLinksRequest = null;

export const getFooterLinksInfo = () => async (dispatch, getState) => {
  const { getFooterLinks, getFooterLinksSuccess, getFooterLinksFailure } = slice.actions;
  const { footerLinks } = getState().global;

  if (footerLinks) {
    return;
  }

  if (footerLinksRequest) {
    return footerLinksRequest;
  }

  footerLinksRequest = (async () => {
    try {
      dispatch(getFooterLinks());
      const response = await axios.get<FooterLinksResponse>(ENDPOINTS.GET_FOOTER_LINKS_ENDPOINTS);
      dispatch(getFooterLinksSuccess(response));
    } catch (err) {
      footerLinksRequest = null;
      dispatch(getFooterLinksFailure(err));
    }
  })();

  return footerLinksRequest;
};

export const resetError = () => dispatch => {
  dispatch(slice.actions.clearError());
  dispatch(clearPublicContentError());
};
export default slice;
